'use client';
import { commerceTestPreview } from '@/lib/commerce-test-preview';

/**
 * The test build serves the real screens so the verification exercises production code paths.
 * It must stay unmistakable which environment the operator is looking at, on every screen.
 */
export function CommerceTestBoundary({ children }: { children: React.ReactNode }) {
  if (!commerceTestPreview) return <>{children}</>;
  return (
    <>
      <p
        role="status"
        className="sticky top-0 z-50 border-b border-amber-300 bg-amber-100 px-4 py-2 text-center text-sm font-semibold text-amber-950"
      >
        検証専用環境です。実際のカード情報・実顧客情報は入力しないでください。
      </p>
      {children}
    </>
  );
}
